<template>
    <div>
        <!-- middle middle section -->
        <div class="main-internal-section width-full float-l">
            <div class="container">
                <div class="row">
                    <div class="chat-btm-section-main width-full float-l"> <!--middle section-->
                        <h2 class="chat-page-title float-l width-full color-333333 heading-text-24 line-height-28 font-bold ucase"> Site list </h2>
                        <div class="chat-sitelist-web border-d1d3d4 float-l col-12">
                            <template v-if="mySiteArr && mySiteArr.length > 0">
                                <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 float-l internal-sile-list" v-for="(site, index) in mySiteArr" :key="index">
                                    <div class="site-listing-section-web float-l" :key="index">
                                        <div class="site-list-section width-full float-l relative border-none">
                                            <span class="bgcolor-9abfd1 radius-100 absolute p_5 float-l l-20 t-4"> </span>
                                            <div class="right-site-list-section float-l width-full pl_50">
                                                <h5 class="float-l width-full heading-text-16 line-height-20 color-333333 font-benton-bold mb_5"> {{site.sectionName | filterString}} </h5>
                                                <span class="color-888888 float-l width-full font-benton-book heading-text-14 line-height-18"> Role: {{site.roleName | filterString}} </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <template v-if="mySiteArr && mySiteArr.length > 0">
                            <div class="site-list-mobile float-l width-full" v-for="(site, index) in mySiteArr" :key="index">  
                                <div class="site-list-section col-12 float-l relative pt_20 pb_20 border-none">
                                    <span class="bgcolor-9abfd1 radius-100 absolute p_5 float-l l-20 t-25"> </span>
                                    <div class="right-site-list-section float-l width-full pl_35">
                                        <h5 class="float-l width-full heading-text-16 line-height-20 color-333333 font-benton-bold mb_5"> {{site.sectionName | filterString}} </h5>
                                        <span class="color-888888 float-l width-full font-benton-book heading-text-14 line-height-18"> Role: {{site.roleName | filterString}} </span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <!-- middle section	  -->
                </div>
            </div> 
        </div>
        <!-- middle middle section -->
        <app-footer></app-footer>
    </div>
</template>

<script>
    import Vue from "vue";
    import Footer from "@/components/partials/Footer";
    import {commonMixins} from '../../mixins/commonMixins';
    import moment from 'moment';
    import EventBus from '../event-bus';
    import {HTTP} from '../../http-common';

    Vue.component("app-footer", Footer);
    export default {
        name: 'SiteList',
        mixins: [commonMixins],
        data () {
            return {
                mySiteArr: []
            }
        },
        mounted: function() {
            var self = this;
            EventBus.$emit("headerMobileView", 'Site List');
            self.loadMySites();
        },
        filters: {
            filterString(data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            }
        },
        methods: {
            loadMySites() {
                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                self.showLoader();
                HTTP.get("my-sites", config)
                        .then(function (data) {
                            if (data.data.code == 200 && data.data.status == 'success') {
                                self.mySiteArr = data.data.content;
                            }
                            self.hideLoader();
                        })
                        .catch(function (error) {
                            self.hideLoader();
                            self.catchHandler(error, function () {});
                        })
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->


// WEBPACK FOOTER //
// src/components/List/SiteList.vue